export interface ICuratedItem {
  id: number
  imageUrl: string
  title: string
  backgroundColor: string
  titleColor: string
}

export const DEFAULT_CURATED_BG_COLOR = '#9C9076'
export const DEFAULT_CURATED_TEXT_COLOR = '#FFFFFF'
